import React from 'react';
const allowedGuns = ['.22 Pistol (Iron or Optics)', '.22 Carbine (Iron or Optics)', 'Centerfire Pistol (Iron or Optics) (No magnum ammo)', 'Centerfire Carbine-PCC (Iron or Optics) (No magnum ammo)'];
export function AllowedFirearms() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3407">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3408">
        <div className="mb-12" data-id="element-3409">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3410">
            Allowed Firearms
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3411">
            <p className="text-base mb-4" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3412">
              The following types of guns can be used:
            </p>
            <ul className="space-y-3" data-id="element-3413">
              {allowedGuns.map((gun, index) => <li key={index} className="flex items-start gap-3" data-id="element-3414">
                  <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'rgba(200,168,75,0.15)',
                border: '1px solid rgba(200,168,75,0.3)'
              }} data-id="element-3415">
                    <div className="w-2 h-2 rounded-full" style={{
                  backgroundColor: '#c8a84b'
                }} data-id="element-3416" />
                  </div>
                  <span className="text-base" style={{
                color: '#2a2a2a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3417">
                    {gun}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}